var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 126,
    viewBox: "0 0 169 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3715 2.2055C28.9534 12.5499 5.73965 39.3791 3.96583 44.5649C0.256934 55.4081 2.29432 65.7416 19.6995 78.9975C35.6683 88.31 78.6887 72.6118 78.5619 58.2166C78.387 38.3854 -14.0478 79.2666 23.4951 106.164C53.5294 127.682 131.199 119.913 166.28 113.339M166.28 113.339L155.619 105.914M166.28 113.339L150.066 123.899",
    stroke: "#252525",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpArrow);
export default __webpack_public_path__ + "static/media/lp-arrow.4c12f4ea737aa2a84e888ccc3105b9a4.svg";
export { ForwardRef as ReactComponent };